import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', () => {
  // Navigation state
  const isNavigationDrawerOpen = ref(false)
  const isCartDrawerOpen = ref(false)

  const openNavigationDrawer = () => {
    isNavigationDrawerOpen.value = true
  }

  const closeNavigationDrawer = () => {
    isNavigationDrawerOpen.value = false
  }

  const openCartDrawer = () => {
    isCartDrawerOpen.value = true
  }

  const closeCartDrawer = () => {
    isCartDrawerOpen.value = false
  }

  const closeAllOverlays = () => {
    isNavigationDrawerOpen.value = false
    isCartDrawerOpen.value = false
  }

  return {
    // State
    isNavigationDrawerOpen,
    isCartDrawerOpen,

    // Actions
    openCartDrawer,
    closeCartDrawer,
    openNavigationDrawer,
    closeNavigationDrawer,
    closeAllOverlays,
  }
})
